import { Box, Text } from '@chakra-ui/react';
import {
  Persona,
  PersonaAvatar,
  PersonaDetails,
  PersonaLabel,
} from '@saas-ui/react';

import { AgentThinkingChromeText, AgentThinkingOrb } from '@/components/core';

type AgentChatPersonaProps = {
  name: string;
  label?: string;
  src?: string;
  isThinking: boolean;
  status?: string | null;
  toolName?: string | null;
  /** Shown under the label while the agent is idle. */
  description?: string | null;
};

export function AgentChatPersona({
  name,
  label,
  src,
  isThinking,
  status,
  toolName,
  description,
}: AgentChatPersonaProps) {
  // The phase only (Thinking…, Working…, Writing…). Tool names and step
  // notes are in the working panel; the orb still reads the tool name.
  const secondary = status?.trim() || 'Thinking…';

  return (
    <Persona>
      {isThinking ? (
        <Box flexShrink={0} lineHeight={0} data-cy='agent-chat-persona-orb'>
          <AgentThinkingOrb size='avatar' status={status} toolName={toolName} />
        </Box>
      ) : (
        <PersonaAvatar
          name={name}
          src={src}
          size='sm'
          presence='online'
          presenceLabel='Online'
        />
      )}
      <PersonaDetails marginInlineStart={3}>
        <PersonaLabel fontSize='lg' lineHeight='7'>
          {label ?? name}
        </PersonaLabel>
        {isThinking ? (
          <Box data-cy='agent-chat-persona-status'>
            <AgentThinkingChromeText isLive>
              {secondary}
            </AgentThinkingChromeText>
          </Box>
        ) : description ? (
          <Text
            fontSize='xs'
            lineHeight='4'
            color='muted'
            noOfLines={1}
            data-cy='agent-chat-persona-description'
          >
            {description}
          </Text>
        ) : null}
      </PersonaDetails>
    </Persona>
  );
}
